import { cn } from '@/utils/cn';

import ActionTooltip from './ActionTooltip';

interface ActionButtonProps {
  isLeft?: boolean;
  icon: React.ReactNode;
  label: string;
  tooltip: string;
  onClick: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({ isLeft, icon, label, tooltip, onClick }: ActionButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation();
    onClick();
  };

  return (
    <ActionTooltip content={tooltip}>
      <button
        type="button"
        aria-label={label}
        className={cn(
          'shrink-0 py-1.5 text-text-secondary hover:text-text-primary transition-colors',
          isLeft ? 'pr-1.5 pl-2' : 'pr-2 pl-1.5',
        )}
        onClick={handleClick}
      >
        {icon}
      </button>
    </ActionTooltip>
  );
};

export default ActionButton;
